import script from "./CourseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseModal.vue?vue&type=script&setup=true&lang=js"

import "./CourseModal.vue?vue&type=style&index=0&id=966c483e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-966c483e"]])

export default __exports__